module.exports = ['RESTService', (RESTService) ->
  RESTService.service('admin/feedbacks')
]
